import type { StringIndexedObject, SelectOption } from "@kanda-libs/ks-component-ts";

export const WORK_TYPE_OPTIONS: SelectOption[] = [
  { name: "Aesthetics", value: "aesthetics" },
  { name: "Air Conditioning", value: "air_conditioning" },
  { name: "Air Source Heat Pumps", value: "air_source_heat_pumps" },
  { name: "Alarm Systems", value: "alarm_systems" },
  { name: "Appliances", value: "appliances" },
  { name: "Artificial Grass", value: "artificial_grass" },
  { name: "Bathrooms Supply And Fitted", value: "bathrooms_supply_and_fitted" },
  { name: "Bathrooms Supply Only", value: "bathrooms_supply_only" },
  { name: "Battery Storage", value: "battery_storage" },
  { name: "Bedrooms Furnitue Custom", value: "bedrooms_furnitue_custom" },
  { name: "Blinds Awnings Shutters", value: "blinds_awnings_shutters" },
  { name: "Boiler Swap", value: "boiler_swap" },
  { name: "Car Body Shop", value: "car_body_shop" },
  { name: "Car Detailing And Alloys", value: "car_detailing_and_alloys" },
  { name: "Carpentry", value: "carpentry" },
  { name: "Carpets", value: "carpets" },
  { name: "Catering", value: "catering" },
  { name: "Cctv", value: "cctv" },
  { name: "Central Heating System", value: "central_heating_system" },
  { name: "Computer Builder", value: "computer_builder" },
  { name: "Conservatory", value: "conservatory" },
  { name: "Conservatory Roof", value: "conservatory_roof" },
  { name: "Damp Proofing", value: "damp_proofing" },
  { name: "Decking", value: "decking" },
  { name: "Dental", value: "dental" },
  { name: "Door Canopy", value: "door_canopy" },
  { name: "Door Internal", value: "door_internal" },
  { name: "Doors", value: "doors" },
  { name: "Driveways", value: "driveways" },
  { name: "Electrical Installation", value: "electrical_installation" },
  { name: "Electronics", value: "electronics" },
  { name: "Entertainers", value: "entertainers" },
  { name: "Ev Charger", value: "ev_charger" },
  { name: "Events", value: "events" },
  { name: "Experiences", value: "experiences" },
  { name: "Fencing", value: "fencing" },
  { name: "Fireplaces", value: "fireplaces" },
  { name: "Fitted Furniture", value: "fitted_furniture" },
  { name: "Flooring Excluding Carpets", value: "flooring_excluding_carpets" },
  { name: "Flowers", value: "flowers" },
  { name: "Foundations", value: "foundations" },
  { name: "Full Events Package", value: "full_events_package" },
  { name: "Furniture", value: "furniture" },
  { name: "Garage Doors", value: "garage_doors" },
  { name: "Garden Buildings", value: "garden_buildings" },
  { name: "Gates", value: "gates" },
  { name: "Glass Splash Backs", value: "glass_splash_backs" },
  { name: "Granite Worktops", value: "granite_worktops" },
  { name: "Graphic Designer", value: "graphic_designer" },
  { name: "Ground Source Heat Pumps", value: "ground_source_heat_pumps" },
  { name: "High End Clothing", value: "high_end_clothing" },
  { name: "Home Lifts", value: "home_lifts" },
  { name: "Home Removals", value: "home_removals" },
  { name: "Home Study", value: "home_study" },
  { name: "Hot Tubs And Spas", value: "hot_tubs_and_spas" },
  { name: "Insulation Roof Foil Wrap Only", value: "insulation_roof_foil_wrap_only" },
  { name: "Jewllery", value: "jewllery" },
  { name: "Kitchens Fitted", value: "kitchens_fitted" },
  { name: "Kitchens Supply Only", value: "kitchens_supply_only" },
  { name: "Landscaping", value: "landscaping" },
  { name: "Loft Boarding", value: "loft_boarding" },
  { name: "Loft Conversion", value: "loft_conversion" },
  { name: "Media Walls", value: "media_walls" },
  { name: "Medical Assessments", value: "medical_assessments" },
  { name: "Memberships", value: "memberships" },
  { name: "Mobillity And Mobility Scooters", value: "mobillity_and_mobility_scooters" },
  { name: "Network Engineer", value: "network_engineer" },
  { name: "Number Plates", value: "number_plates" },
  { name: "Other", value: "other" },
  { name: "Painting And Decorating", value: "painting_and_decorating" },
  { name: "Patios", value: "patios" },
  { name: "Personal Security", value: "personal_security" },
  { name: "Photography", value: "photography" },
  { name: "Planners", value: "planners" },
  { name: "Plastering", value: "plastering" },
  { name: "Porch", value: "porch" },
  { name: "Rendering", value: "rendering" },
  { name: "Resin Driveways", value: "resin_driveways" },
  { name: "Roofing", value: "roofing" },
  { name: "Roofing Excl Flat Roofs", value: "roofing_excl_flat_roofs" },
  { name: "Roofline", value: "roofline" },
  { name: "Security Lighting", value: "security_lighting" },
  { name: "Solar Pv Panels", value: "solar_pv_panels" },
  { name: "Sports Equipment", value: "sports equipment" },
  { name: "Spray Foam Removal", value: "spray_foam_removal" },
  { name: "Stair Lifts", value: "stair_lifts" },
  { name: "Staircases", value: "staircases" },
  { name: "Technology Repair", value: "technology_repair" },
  { name: "Tiling", value: "tiling" },
  { name: "Tool Sales", value: "tool sales" },
  { name: "Tyres", value: "tyres" },
  { name: "Under Stair Storage", value: "under_stair_storage" },
  { name: "Underfloor Heating", value: "underfloor_heating" },
  { name: "Upvc Doors", value: "upvc_doors" },
  { name: "Vehicle Wrapping", value: "vehicle_wrapping" },
  { name: "Venues", value: "venues" },
  { name: "Verandas", value: "verandas" },
  { name: "Wall Insulation And Cladding", value: "wall_insulation_and_cladding" },
  { name: "Wardrobes", value: "wardrobes" },
  { name: "Water Softeners", value: "water_softeners" },
  { name: "Website Builder", value: "website_builder" },
  { name: "Windows", value: "windows" },
  { name: "Windows And Doors", value: "windows_and_doors" },
];

export const ADD_COMPANY_FORM_ID = "staff-add-company-form";

export const BUSINESS_SECTOR_OPTIONS: SelectOption[] = [
  { name: "Home improvement", value: "Home improvement" },
  { name: "Renewables", value: "Renewables" },
  { name: "Retail", value: "Retail" },
  { name: "IT and technology Services", value: "IT and technology Services" },
  { name: "Automotive services", value: "Automotive services" },
  { name: "Training and education", value: "Training and education" },
  { name: "Events (including weddings)", value: "Events (including weddings)" },
  { name: "Healthcare", value: "Healthcare" },
  { name: "Other", value: "Other" },
];

export const DEFAULT_VALUES: StringIndexedObject = {
  company: {
    company_type: "limited_company",
    quote_preference: "kanda",
    limited_company_info: { company_address: { country: "United Kingdom" } },
    company_info: { work_types: [], work_types__selected: "" },
  },
};

export const COMPANY_ADDRESS_FIELD_NAMES = {
  companyNumberName: "company.limited_company_info.company_number",
  buildingNumberName:
    "company.limited_company_info.company_address.building_number",
  addressLineOneName: "company.limited_company_info.company_address.line_1",
  addressLineTwoName: "company.limited_company_info.company_address.line_2",
  cityName: "company.limited_company_info.company_address.city",
  countyName: "company.limited_company_info.company_address.county",
  countryName: "company.limited_company_info.company_address.country",
  postalCodeName: "company.limited_company_info.company_address.postcode",
};
